<div #dropdownContainer class="ccl-dropdown" [style.width]="width" [ngClass]="customClass">
  <!-- Dropdown Trigger -->
  <div 
    #dropdownTrigger
    class="ccl-dropdown__trigger"
    [class.ccl-dropdown__trigger--disabled]="disabled"
    [class.ccl-dropdown__trigger--open]="isOpen"
    (click)="toggleDropdown($event)"
  >
    <div class="ccl-dropdown__trigger-content">
      @if (filterIcon) {
        <span class="ccl-dropdown__filter-icon">
          @if (filterIconTemplate) {
            <ng-container *ngTemplateOutlet="filterIconTemplate"></ng-container>
          } @else {
            <span [innerHTML]="filterIconContent"></span>
          }
        </span>
      }
      <span class="ccl-dropdown__display-text">{{ getDisplayText() }}</span>
      <span class="ccl-dropdown__arrow" [class.ccl-dropdown__arrow--open]="isOpen">
        @if (arrowIconTemplate) {
          <ng-container *ngTemplateOutlet="arrowIconTemplate"></ng-container>
        } @else {
          <span [innerHTML]="arrowIconContent"></span>
        }
      </span>
    </div>
  </div>

  <!-- Dropdown Menu -->
  @if (isOpen) {
    <div 
      #dropdownMenu
      class="ccl-dropdown__menu"
      [style.max-height]="maxHeight"
      (click)="$event.stopPropagation()"
    >
      <!-- Search Bar -->
      @if (searchable) {
        <div class="ccl-dropdown__search">
          <input
            type="text"
            class="ccl-dropdown__search-input"
            [placeholder]="searchPlaceholder"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            (click)="$event.stopPropagation()"
          />
          <span class="ccl-dropdown__search-icon">
            @if (searchIconTemplate) {
              <ng-container *ngTemplateOutlet="searchIconTemplate"></ng-container>
            } @else {
              <span [innerHTML]="searchIconContent"></span>
            }
          </span>
        </div>
      }

      <!-- Options List -->
      <div class="ccl-dropdown__options" (click)="$event.stopPropagation()">
        @for (option of filteredOptions; track option.value) {
          <div 
            class="ccl-dropdown__option"
            [class.ccl-dropdown__option--selected]="option.selected"
            [class.ccl-dropdown__option--disabled]="option.disabled"
            (click)="selectOption(option)"
          >
            @if (showCheckboxes && multiple) {
              <span class="ccl-dropdown__checkbox">
                <input 
                  type="checkbox" 
                  [checked]="option.selected"
                  [disabled]="option.disabled"
                  (click)="selectOption(option); $event.stopPropagation()"
                />
              </span>
            }
            @if (customTemplate) {
              <ng-container
                *ngTemplateOutlet="customTemplate; context: { $implicit: option }"
              ></ng-container>
            } @else {
              <span class="ccl-dropdown__option-label">{{ option.label }}</span>
            }
          </div>
        }
        
        @if (filteredOptions.length === 0) {
          <div class="ccl-dropdown__no-results">
            No options found
          </div>
        }
      </div>
    </div>
  }
</div>
